// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iQ9c","colBig":"styles_colBig__XmmQq","colSmall":"styles_colSmall__3eKZO"};